import React, { Component } from 'react';
import Topbar from '../topbar/topbar';
import Projectlist from '../projectlist/projectlist';
import Menu from '../menu/menu';

import './projects.css';
import {Helmet} from "react-helmet";

class Projects extends Component {
    componentDidMount() {
        window.scrollTo(0,0);
    }

    render() {
        return (
            <div className="projects">
                <Helmet>
                    <title>Waar we trots op zijn - KWOOT</title>
                    <meta property="og:title" content={"Waar we trots op zijn - KWOOT"} />
                </Helmet>
                <Menu/>
                <Topbar></Topbar>
                <Projectlist></Projectlist>
            </div>
        );
    }
}

export default Projects;



// WEBPACK FOOTER //
// ./src/components/projects/projects.js